<template>
  <div class='trailDialog'>
    <el-dialog 
      v-model="curDialogVisible" 
      center
      :show-close="false"
      :close-on-click-modal="false"
      @closed="escClose">
      <el-table 
        class="table"
        ref="dragTable"
        :data="dataList" 
        border
        width="100%"
        fit
        :header-cell-style="{
          background: '#ECF2FE',
          borderColor: '#999999'
        }"
        :cell-style="{
          borderColor: '#999999'
        }"
        v-loading="loading">
        <el-table-column fixed width="530" align="center">
          <template #header>
            <div class="header-title">TRAIL</div>
          </template>
          <template #default="scope">
          <div class="trial-bg">
            <el-checkbox class="trail-checkbox" v-model="scope.row.isSelected" :disabled="scope.row.disabled" @change="checkTrialDo(scope.row)"></el-checkbox>
            <div class="table-trial">
              {{ scope.row.trail }}
            </div>
          </div>
          </template>
        </el-table-column>

        <el-table-column width="160" align="center">
          <template #header>
            <div class="header-title">CREATEDAT</div>
          </template>
          <template #default="scope">
            <div class="table-other">
              {{ scope.row.createDate }}
            </div>
          </template>
        </el-table-column>

        <el-table-column width="110" align="center">
          <template #header>
            <div class="header-title">STATUS</div>
          </template>
          <template #default="scope">
            <div class="table-other">
              {{ scope.row.status }}
            </div>
          </template>
        </el-table-column>

        <el-table-column width="120" align="center">
          <template #header>
            <div class="header-title">RETENTION</div>
          </template>
          <template #default="scope">
            <div class="table-other">
              {{ scope.row.retention }}
            </div>
          </template>
        </el-table-column>

        <el-table-column width="150" align="center">
          <template #header>
            <div class="header-title">TITLE</div>
          </template>
          <template #default="scope">
            <div class="table-other">
              {{ scope.row.title }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center">
          <template #header>
            <div class="header-title">DESCRIPTION</div>
          </template>
          <template #default="scope">
            <div class="table-other">
              {{ scope.row.describle }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="page-bg">
        <div class="page-left">共 {{totalCount }} 项数据</div>
        <el-pagination 
          class="page-right" 
          background 
          layout="prev, pager, next" 
          :total="totalCount" 
          :page-size="pageSie"
          :current-page="currentPage" 
          @current-change="currentDo">
        </el-pagination>
      </div>
      <div class="btn-box">
        <el-button class="btn btn1" @click="cancelDo">Cancel</el-button>
        <el-button class="btn btn2" @click="confirmDo">Confirm</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'trailDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    allDataList: {
      type: Array,
      default: () => []
    },
    totalCount: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }

  },
   watch: {
    dialogVisible(val) {
      this.curDialogVisible = val;
    },
  },
  data() {
    return {
      curDialogVisible: false,
      currentPage: 1,
      pageSie: 8,
      // dataList: [],
 
    }
  },
  computed: {
    dataList() {
      const list = this.allDataList.filter(model => {
        return model.key == this.currentPage
      })
      return list.shift()?.list
    }
  },
  methods: {
    checkTrialDo(item) {
      this.$emit("checkTrialDo", item)
    },
    escClose() {
      this.$emit("cancelDo")
    },
    nextDo(index) {
      this.currentPage = index
    },
    preDo(index) {
      this.currentPage = index
    },
    currentDo(index) {
      this.currentPage = index
      this.$emit("changePage", index)
    },
    confirmDo() {
      this.$emit("confirmDo")
      
    },
    cancelDo() {
      this.$emit("cancelDo")
    },
  },
  created() {
  }
}
</script>
<style lang='less' scoped>
 .trailDialog {
  // width: 100vw;
  // background-color: red;
 } 

 .table {
  width: 100%;
  border: 1px solid #999999;
 }

 .header-title {
  height: 45px;
  display:flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
 }

 .trial-bg {
  display: flex;
  align-items: center;
  // justify-content: center;
  padding: 11px 5px 11px 15px;

  .trail-checkbox {
    // height: 15px;
    // width: 15px;
    // background-color: red;
    // margin-le
  }

  .table-trial {
    margin-left: 10px;
    color: #383838;
    font-size: 14px;
    font-weight: 400;
  }
 }

 .table-other {
  color: #383838;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
 }

 .page-bg {
  display: flex;
  // height: 35px;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
  margin-top: 10px;
  .page-left {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
 }

 .btn-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  .btn {
    height: 38px;
    width: 160px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn1 {
    background-color: #F5F5F5;
    border: 1px solid #A6A6A6;
    color: #A6A6A6;

  }
  .btn2 {
    background-color: #0052D9;
    border: 1px solid #0052D9;
    color: #ffffff;
  }
 }

:deep(.el-dialog) {
  border-radius: 8px;
  // height: 700px !important;
  padding: 0px 20px 0px 20px; 
  width: 1322px !important;
}

//, .el-checkbox__input
:deep(.el-checkbox__input .el-checkbox__input) {
  height: 16px !important;
  width: 16px !important;
}

:deep(.el-table .cell) {
  padding: 0px !important;
}
:deep(.el-table td) {
  padding: 0px !important;
}

:deep(.el-table th) {
  padding: 0px !important;
  user-select: initial !important;
}

:deep(.el-table tr) {
  padding:  0px !important;
}

:deep(.el-button) {
  min-height: 38px !important;
}

/*
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 1px solid #EBEEF5;
}
<style>
.el-table td, .el-table th.is-leaf {
    border-bottom: 1px solid #EBEEF5;
}

.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 1px solid #EBEEF5;
}

.el-table td, .el-table th.is-leaf

*/

// :deep(.el-table__header-wrapper .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed ) {
//     border-right: 1px solid #999999 !important;
// }

// :deep(.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed) {
//   border-right: 1px solid #999999;
// }

// :deep(.el-table td, .el-table th.is-leaf) {
//   border-bottom: 1px solid #999999;
// }


</style>